module.exports = __webpack_public_path__ + "static/media/29ADMSPC19.98f25d31.jpg";